import * as React from 'react';
import capitalize = require('lodash/capitalize');  // tslint:disable-line: no-require-imports

interface Props {
	headers: FrontendExternalServiceIntegrationHeader[];
	onChange(headers: FrontendExternalServiceIntegrationHeader[]): void;
}

interface State {
	headers: FrontendExternalServiceIntegrationHeader[];
}

export default class ExternalRaterHeaders extends React.Component<Props, State> {

	public state: State = {
		headers: this.props.headers,
	};

	constructor(props: Props, context: any) {
		super(props, context);
		this.handleAddExternalRaterHeader = this.handleAddExternalRaterHeader.bind(this);
		this.handleChangeExternalRaterHeader = this.handleChangeExternalRaterHeader.bind(this);
		this.handleDeleteExternalRaterHeader = this.handleDeleteExternalRaterHeader.bind(this);
		this.propagateHeaderChanges = this.propagateHeaderChanges.bind(this);
	}

	public render() {
		return <div className='external-service-integration-headers text-align-right'>
			{this.renderAddHeaderLink()}
			{this.renderHeaders()}
		</div>;
	}

	private renderAddHeaderLink() {
		return <a onClick={this.handleAddExternalRaterHeader}>
			Add Header
		</a>;
	}

	private renderHeaders() {
		return this.state.headers.map((h, i) => {
			return this.renderHeader(h, i);
		});
	}

	private renderHeader(header: FrontendExternalServiceIntegrationHeader, index: number) {
		const className = `row external-rater-header`;
		return <div key={index} className={className}>
			<div className='columns small-5 text-align-right'>
				{this.renderHeaderField('name', header.name, index)}
			</div>
			:
			<div className='columns small-6'>
				{this.renderHeaderField('value', header.value, index)}
			</div>
			{this.renderDeleteIcon(index)}
		</div>;
	}

	private renderHeaderField(
		type: 'name' | 'value',
		value: string,
		headerIndex: number,
	) {
		return <textarea
			className={type === 'name' ? 'text-align-right' : ''}
			placeholder={capitalize(type)}
			value={value}
			data-header-name-or-value={type}
			data-header-index={headerIndex}
			onChange={this.handleChangeExternalRaterHeader}
		/>;
	}

	private renderDeleteIcon(headerIndex: number) {
		return <div className='columns small-1'>
			<i
				className='fa fa-trash is-red'
				data-header-index={headerIndex}
				onClick={this.handleDeleteExternalRaterHeader}
			/>
		</div>;
	}

	private handleAddExternalRaterHeader() {
		this.setState({
			...this.state,
			headers: [
				...this.state.headers,
				{name: '', value: ''},
			],
		}, this.propagateHeaderChanges);
	}

	private handleChangeExternalRaterHeader(event: React.FormEvent<HTMLTextAreaElement>) {
		const currentTarget = event.currentTarget as HTMLTextAreaElement;
		const headerIndex = currentTarget.getAttribute('data-header-index');
		const nameOrValue = currentTarget.getAttribute('data-header-name-or-value');
		const inputValue = currentTarget.value;
		const headers = this.state.headers.map((h, i) => {
			if (i === parseInt(headerIndex, 10)) {
				return {...h, [nameOrValue]: inputValue};
			} else {
				return h;
			}
		});
		this.setState({
			...this.state,
			headers,
		}, this.propagateHeaderChanges);
	}

	private handleDeleteExternalRaterHeader(event: React.MouseEvent<HTMLElement>) {
		const headerIndex = (event.currentTarget as HTMLElement)
			.getAttribute('data-header-index');
		const headers = this.state.headers.filter((h, i) => i !== parseInt(headerIndex, 10));
		this.setState({
			...this.state,
			headers,
		}, this.propagateHeaderChanges);
	}

	private propagateHeaderChanges() {
		this.props.onChange(this.state.headers);
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/util/external-service-integrations/modifiable/ExternalRaterHeaders.tsx